import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { UpdateFindingMutation, UpdateFindingInput } from '#/graphql/types';
import { updateFinding } from '#/graphql/mutations';
import { get } from 'lodash';
import { GET_FINDING } from './useFindingQuery';

const q = gql(updateFinding);

const useFindingUpdate = () => {
  const [mutation, result] = useMutation<UpdateFindingMutation>(q);
  const updateFinding = useCallback(
    async (id: string, data: UpdateFindingInput) => {
      const response = await mutation({
        variables: {
          id,
          data,
        },
        refetchQueries: [{ query: GET_FINDING, variables: { id: id } }],
        awaitRefetchQueries: true,
      });

      const result = get(response, 'data.updateFinding', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Update failed';
        throw new Error(errorMessage);
      }

      return get(result, 'data', undefined);
    },
    [mutation],
  );

  return { updateFinding, result };
};

export default useFindingUpdate;
